export enum ContentType {
    applicationFhirJson = 'application/fhir+json',
    applicationFhirXml = 'application/fhir+xml',
    applicationJson = 'application/json',
    applicationJsonFhir = 'application/json+fhir',
    applicationPdf = 'application/pdf',
    applicationXmlFhir = 'application/xml+fhir',
}
